/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useContext } from "react";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import { Button } from "@material-ui/core";
import Page from "components/common_components/Page/Page";
import useStyles from "../useStyles";
import { useDispatch, useSelector } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import ModulesContext from "../ModulesContext";
import Grid from "@material-ui/core/Grid";
import AddIcon from "@material-ui/icons/Add";
import { getAdvancedFiltersContext } from "./AdvancedFiltersContexts";
import { getAdvancedFiltersComponent } from "./AdvancedFilters";
import { getAdvancedFiltersNormalizers } from "./AdvancedFiltersNormalizers";

function List({ goToDetail, goToAdd, listHead, filterBuilder, formName, filterValue, onFilterChange }) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.Login);
    const { PersonalInfo, personalInfoData, Log, moduleCode, pageableData, getFileCases, setCurrentFileCase, isLoading, permissions } =
        useContext(ModulesContext);
    const AdvancedFiltersContext = getAdvancedFiltersContext(formName);
    const AdvancedFiltersComponent = getAdvancedFiltersComponent(formName);
    const AdvancedFiltersNormalizers = getAdvancedFiltersNormalizers(formName);

    useEffect(() => {
        if (getFileCases) getFileCases();
    }, []);

    async function onRowClickHandler(item) {
        let newItem = { ...item };
        try {
            Log.add({
                payload: {
                    event: "FILE_CASE_VISIT",
                    logDate: new Date().getTime(),
                    description: `The user ${user.name} has visited the File No. ${item.fileNo}. Module_Code: ${moduleCode}, User_Id: ${user.id}.`,
                    userId: user.id,
                },
            });
        } catch (error) {}
        try {
            if (item.parentId) {
                const parent = await PersonalInfo.getOneByIdAsync(item.parentId);
                if (parent) {
                    newItem = { ...item, parent };
                }
            }
        } catch (error) {}
        setCurrentFileCase(newItem);
        goToDetail();
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getFileCases();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        PersonalInfo.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    return (
        <Page className={classes.root}>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <Grid container spacing={3} style={{ justifyContent: "space-between" }}>
                    <Grid item md={6}>
                        {permissions.list.actions.add && (
                            <Button
                                variant="text"
                                size="medium"
                                color="primary"
                                startIcon={<AddIcon />}
                                onClick={() => {
                                    setCurrentFileCase(undefined);
                                    goToAdd();
                                }}
                            >
                                Add
                            </Button>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <EnhancedTable
                            headCells={listHead}
                            data={personalInfoData}
                            defaultOrder={{ order: "desc", orderBy: "id" }}
                            keyColumnName="id"
                            selectable={permissions.list.actions.delete}
                            deletable={permissions.list.actions.delete}
                            onRowClick={onRowClickHandler}
                            onDelete={onDeleteHandler}
                            onRequestData={getFileCases}
                            filterBuilder={filterBuilder}
                            pageableData={pageableData}
                            presetFilterValue={filterValue}
                            onFilterChange={onFilterChange}
                            advancedFiltersProps={{
                                context: AdvancedFiltersContext,
                                component: AdvancedFiltersComponent,
                                normalizers: AdvancedFiltersNormalizers,
                            }}
                        />
                    </Grid>
                </Grid>
            )}
        </Page>
    );
}

export default List;
